<script setup lang="ts">
import type { AccordionRootEmits, AccordionRootProps } from 'reka-ui'
import { AccordionRoot, useForwardPropsEmits } from 'reka-ui'

const props = defineProps<AccordionRootProps>()
const emits = defineEmits<AccordionRootEmits>()

const forward = useForwardPropsEmits(props, emits)
</script>

<template>
  <AccordionRoot v-bind="forward" class="flex flex-col gap-4">
    <slot />
  </AccordionRoot>
</template>
